"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var body_scroll_lock_1 = require("body-scroll-lock");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_modal_1 = __importDefault(require("react-modal"));
react_modal_1.default.setAppElement('#react-modal');
var ActionSheet = function (_a) {
    var children = _a.children, className = _a.className, closeClassNames = _a.closeClassNames, disableClose = _a.disableClose, handleClose = _a.handleClose, isOpen = _a.isOpen, style = _a.style;
    // we never nullify this element, even when scrollableElement is nullified, in case it gets nullified on close before we get a chance to re-enable body scroll
    var _b = __read((0, react_1.useState)(null), 2), preservedScrollableElement = _b[0], setPreservedScrollableElement = _b[1];
    var scrollableElCallback = (0, react_1.useCallback)(function (ref) {
        if (ref)
            setPreservedScrollableElement(ref);
    }, []);
    var onAfterOpen = function (scrollElement) {
        if (scrollElement) {
            (0, body_scroll_lock_1.disableBodyScroll)(scrollElement);
        }
    };
    var onAfterClose = function (scrollElement) {
        if (scrollElement) {
            (0, body_scroll_lock_1.enableBodyScroll)(scrollElement);
        }
    };
    // TODO: pass scroll ref into child so that child gets to decide which element should be scrollable
    return (react_1.default.createElement(react_modal_1.default, { contentRef: scrollableElCallback, className: (0, classnames_1.default)(className, 'content', 'modal--action-sheet'), isOpen: isOpen, onRequestClose: handleClose, onAfterClose: function () { return onAfterClose(preservedScrollableElement); }, onAfterOpen: function () { return onAfterOpen(preservedScrollableElement); }, overlayClassName: 'modal grid-y align-middle align-center modal--action-sheet__overlay', shouldCloseOnEsc: false, shouldCloseOnOverlayClick: !disableClose, style: style },
        !disableClose && (react_1.default.createElement("div", { className: 'position-absolute right-1 top-1', style: { zIndex: 80, width: 40, height: 40, borderRadius: 5, backgroundColor: '#f9f9f9' } },
            react_1.default.createElement("a", { className: 'width-100 height-100', onClick: handleClose, style: { display: 'flex', alignItems: 'center', justifyContent: 'center' } },
                react_1.default.createElement("i", { className: closeClassNames || 'ss-delete', style: { fontSize: '1.125rem' } })))),
        react_1.default.createElement("div", null, children)));
};
exports.default = ActionSheet;
